// Light/dark theme toggle (dark-theme-system).
//
// <html data-theme> is server-rendered from the `theme` cookie (see
// layouts/application.html.erb); this module just flips the attribute live —
// instant, no reload; the CSS swaps the sun/moon icon off the same attribute —
// and re-writes the cookie so the next request paints the same theme.
// A delegated listener survives Turbo body swaps. If cookies are blocked the
// DOM flip still works for the session; the choice just doesn't persist.

const LIGHT = 'cfpk'
const DARK = 'cfpk-dark'

function applyTheme(theme) {
  document.documentElement.dataset.theme = theme
  document.cookie = `theme=${theme}; max-age=31536000; path=/; samesite=lax`
}

document.addEventListener('click', (e) => {
  if (!e.target.closest('[data-theme-toggle]')) return
  applyTheme(document.documentElement.dataset.theme === DARK ? LIGHT : DARK)
})
